import { render, staticRenderFns } from "./ActionButtonPanel.vue?vue&type=template&id=54d80b0c&scoped=true&"
import script from "./ActionButtonPanel.vue?vue&type=script&lang=ts&"
export * from "./ActionButtonPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ActionButtonPanel.vue?vue&type=style&index=0&id=54d80b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d80b0c",
  null
  
)

export default component.exports